import { WithdrawContext } from '@/app/contexts/WithdrawContext'
import { useManualWithdraw } from '@/app/hooks/useManualWithdraw'
import { zodResolver } from '@hookform/resolvers/zod'
import { useContext, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

const formValidation = z.object({
  value: z
    .string()
    .min(1, 'Valor de saque é brigatório')
    .refine((f) => +f.replace(/\D/g, '') > 0, 'Deve ser maior que R$0,00')
    .transform((f) => +f.replace(/\D/g, '') || 0),
})

type formData = z.infer<typeof formValidation>

export const useMakeWithdrawalModalController = ({
  onClose,
  open,
}: {
  onClose: () => void
  open: boolean
}) => {
  const { sellerId } = useContext(WithdrawContext)
  const { manuallyWithdraw } = useManualWithdraw()

  const form = useForm<formData>({
    resolver: zodResolver(formValidation),
  })

  const {
    register,
    formState: { errors, isSubmitting },
    handleSubmit,
    reset,
  } = form

  const onSubmit = async ({ value }: formData) => {
    if (!sellerId) return

    try {
      await manuallyWithdraw({
        amount: value,
        user: sellerId,
        status: 'PAID',
      })
      onClose()
      reset()
    } catch (e) {}
  }

  useEffect(() => {
    if (!open) reset()
  }, [open, reset])

  return {
    form,
    errors,
    register,
    isSubmitting,
    handleSubmit,
    onSubmit,
  }
}
